import { ApisauceInstance } from 'apisauce';

// POST /v1/driver_bonus/tags/remove — removes `tag` from each record's userTags doc.
// Program/period/driver go in the query string; tags/records/data_type in the body
// (data_type is required by the backend, same as the add endpoint).
const removeBonusTag = ({
  api,
  bonusProgramId,
  period,
  driver,
  tag,
  recordIds,
  dataType,
}: {
  api: ApisauceInstance;
  bonusProgramId: string;
  period: string;
  driver: string;
  tag: string;
  recordIds: string[];
  dataType: string;
}) => {
  return api.post<BonusTags.TagMutationResponse>(
    `/v1/driver_bonus/tags/remove?driver_bonus_program_id=${bonusProgramId}&period=${period}&driver=${driver}`,
    {
      tags: [tag],
      records: recordIds,
      data_type: dataType,
    },
  );
};

export default removeBonusTag;
